import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import icons from "./icons"

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#2c569F",
                secondary: "#002B36",
                accent: "#099247",
                accent2: "#2953D3",
                fondo: "#F8F8F8",
                grisClaro:"#2c569F",
                info:"#b8b8b8",
                azulBtn:"#d1d9f7",
                azulFondo:"#EDF1F7",
                azulClaro:"#E9EDFA",
                azulMuyClaro: "#F9FAFE",
                verde: "#18dcc2",
                amarillo: "#FFBA3F",
                neftysBlue: "#2c569F",
                neftysGreen: "#2c569F",
            }
        }
    },
    icons: {
        values: icons.values,
    }
  });
